<template>
  <div>
    <a-alert v-if="loading" message="Regio's worden opgehaald..." type="info" :show-icon="true"/>

    <a-select
        v-else-if="allRegions.length"
        placeholder="Selecteer een regio"
        mode="multiple"
        v-model="selectedValues"
        :allowClear="allowClear"
        :show-search="showSearch"
        option-filter-prop="children"
        :filter-option="filterOption"
        @change="onChange">
      <a-select-option
          v-for="region in allRegions"
          :key="region.id"
          :value="region.id">
        {{ region.name }}
      </a-select-option>
    </a-select>

    <a-alert v-else message="Geen regio's gevonden." type="warning" :show-icon="true"/>

    <input type="hidden"
           :name="fieldName"
           v-for="regionId in selectedValues"
           :key="regionId"
           :value="regionId"/>
  </div>
</template>

<script>
import regionApi from '~/api/region';

export default {
  name: "RegionSelectComponent",
  props: {
    selectedRegionIds: {
      type: Array,
      default: () => ([])
    },
    fieldName: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.loading = true;
    regionApi.getRegions()
        .then((response) => {
          this.allRegions = response.data;
        })
        .catch(() => {
          this.$notification['error']({
            message: 'Er ging iets mis',
            description: `Het is niet gelukt de regio's te laden`,
          })
        })
        .finally(() => {
          this.loading = false;
        });

    if (this.selectedRegionIds !== null) {
      if (this.selectedRegionIds.length > 0) {
        this.selectedValues = this.selectedRegionIds.map(idString => parseInt(idString));
      }
    }
  },
  data() {
    return {
      loading: false,
      allRegions: [],
      selectedValues: [],
      showSearch: true,
      allowClear: true
    }
  },
  methods: {
    onChange(value) {
      this.selectedValues = value;
      this.$emit('change', this.selectedValues);
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  }
}
</script>

<style scoped>

</style>